// src/icons/Sidebar.tsx
import { jsx } from "@emotion/react/jsx-runtime";
function Sidebar({
  strokeWidth = "1.5",
  strokeLinecap = "round",
  strokeLinejoin = "round"
}) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M5 1H13C14.1046 1 15 1.89543 15 3V8M5 1H3.1875H3C1.89543 1 1 1.89543 1 3V13C1 14.1046 1.89543 15 3 15H5M5 1V5V8M5 15H13C14.1046 15 15 14.1046 15 13V8M5 15V8M5 8H15",
          stroke: "currentColor",
          strokeWidth,
          strokeLinecap,
          strokeLinejoin
        }
      )
    }
  );
}

export {
  Sidebar
};
